import React from 'react'
import { type LucideProps } from 'lucide-react'

const Shop: React.FC<LucideProps> = (props: LucideProps) => (
  <svg
    width={17}
    height={22}
    viewBox="0 0 17 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M16.3169 6.28404H13.4623V5.27564C13.4623 2.80506 11.3145 0.813477 8.70459 0.813477C6.09467 0.813477 3.94689 2.80508 3.94689 5.27564V6.28404H1.09227C0.71163 6.28404 0.412598 6.56133 0.412598 6.91429V19.5193C0.412598 20.4268 1.20104 21.1579 2.17974 21.1579H15.2294C16.2081 21.1579 16.9966 20.4268 16.9966 19.5193V6.91429C16.9966 6.56133 16.6975 6.28404 16.3169 6.28404ZM5.30623 5.25045C5.30623 3.48575 6.82867 2.04879 8.70459 2.04879C10.5805 2.04879 12.1029 3.48571 12.1029 5.25045V6.25885H5.30623V5.25045ZM15.2294 19.8974H2.17974C1.96221 19.8974 1.77194 19.721 1.77194 19.5193V7.54456H3.94689V11.0235C3.94689 11.3765 4.24592 11.6538 4.62656 11.6538C5.0072 11.6538 5.30623 11.3765 5.30623 11.0235V7.54456H12.1029V11.0235C12.1029 11.3765 12.402 11.6538 12.7826 11.6538C13.1633 11.6538 13.4623 11.3765 13.4623 11.0235V7.54456H15.6372V19.5193C15.6372 19.7209 15.447 19.8974 15.2294 19.8974Z"
      fill="#949494"
    />
  </svg>
)

export default Shop
